import { render } from "./AuditInformation.vue?vue&type=template&id=5327bbf1&scoped=true"
import script from "./AuditInformation.vue?vue&type=script&lang=ts"
export * from "./AuditInformation.vue?vue&type=script&lang=ts"

import "./AuditInformation.vue?vue&type=style&index=0&id=5327bbf1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5327bbf1"

export default script